import { Directive, SimpleChanges } from '@angular/core';
import { DataView } from 'primeng/dataview';

@Directive({
  selector: '[vnmDataViewSortFix]'
})
export class DataViewSortFixDirective {
  constructor(dataView: DataView) {
    // Get the original implementation of ngOnChanges and bind it to the dataView
    const proto = Object.getPrototypeOf(dataView);
    const ngOnChanges = proto.ngOnChanges.bind(dataView);
    // Redefine the ngOnChanges function, call the original, and sort
    Object.defineProperty(dataView, 'ngOnChanges', {
      value: (changes: SimpleChanges) => {
        ngOnChanges(changes);
        dataView.sort();
      }
    });
  }
}
